import React, { useEffect, useRef, useState, useMemo, useLayoutEffect } from 'react';
import { Dropdown, Menu, message, Modal } from 'antd';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import { useAppSelector, useAppDispatch, MailActions } from '@web-common/state/createStore';
import { apiHolder, apis, getIn18Text, isEdm, inWindow } from 'api';
import { LIST_MODEL } from '@web-mail/common/constant';
import cloneDeep from 'lodash/cloneDeep';
import useLocalStorage from '@/hooks/useLocalStorage';
import styles from './index.module.scss';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { TongyongGuanbiXian } from '@sirius/icons';
import { ReactComponent as QiyeIcon } from '@/images/icons/qiye.svg';
import AIIconCommon from '@/images/icons/AIIconCommon.png';
import { ReactComponent as AIIconAdmin } from '@/images/icons/AIIconAdmin.svg';
import AIIconSD from '@/images/icons/AIIconSDNew.png';
import { ReactComponent as AIIconResign } from '@/images/icons/AIIconResign.svg';
import { ReactComponent as AIIconNew } from '@/images/icons/AiIconNew.svg';
import { ReactComponent as CloudeUploadIcon } from '@/images/icons/sidebar/upload.svg';
import { tabType } from '@web-common/state/reducer/mailTabReducer';
import configBg from './image/configBg.png';
import subordinateEdit from './image/subordinateEdit.png';
import chosen from './image/chose.png';
import IconCard from '../UI/IconCard';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { ReactComponent as IconTriangleDown } from '@/images/icons/toolbar_triangle_down.svg';
import loadable from '@loadable/component';
import { config as conf } from 'env_def';
import { Loading } from '@web-common/components/UI/Loading';
const SUB_PATH = conf('contextPath') || '';
const aiAssistant = apiHolder.api.requireLogicalApi(apis.aiAssistant);
const aiAssistantApi = apiHolder.api.requireLogicalApi(apis.aiAssistant);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfigApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const eventApi = apiHolder.api.getEventApi();
export const AiAssistantSidebar = () => {
    var _a, _b;
    const ref = useRef(null);
    const aiAssistSideBarVisiable = useAppSelector(state => state.mailReducer.aiAssistSideBarVisiable);
    const [isRender, setRender] = useState(false);
    useEffect(() => {
        var _a, _b;
        let timeout;
        if (!aiAssistSideBarVisiable) {
            timeout = setTimeout(() => {
                aiAssistantApi.sendNotification({ type: 'tipOpen', data: false });
            }, 500);
        }
        if (!ref.current || !aiAssistSideBarVisiable)
            return;
        if (!isRender) {
            setRender(true);
            (_a = window.smartAssistantWeb) === null || _a === void 0 ? void 0 : _a.render({
                container: ref.current,
                deviceId: '',
                data: { route: '/' },
            });
        }
        else {
            aiAssistantApi.offAllNotification();
            (_b = window.smartAssistantWeb) === null || _b === void 0 ? void 0 : _b.update({
                container: ref.current,
                deviceId: '',
                data: { route: '/' },
            });
        }
        return () => {
            timeout && clearTimeout(timeout);
        };
    }, [aiAssistSideBarVisiable]);
    useEffect(() => {
        let eid;
        if (aiAssistSideBarVisiable) {
            eid = eventApi.registerSysEventObserver('assistantContextChanged', {
                func: ev => {
                    if (ev && ev.eventData && ev.eventStrData && ev.eventStrData === 'toast') {
                        message.open({ type: ev.eventData.type || 'info', content: ev.eventData.title || getIn18Text('AIZHUSHOUSHIBAI'), duration: ev.eventData.duration || 3 });
                    }
                },
            });
        }
        return () => {
            eventApi.unregisterSysEventObserver('assistantContextChanged', eid);
        };
    }, [aiAssistSideBarVisiable]);
    return (React.createElement(React.Fragment, null, aiAssistSideBarVisiable && !process.env.BUILD_ISEDM ? (React.createElement("div", { id: "ai-assistant-wrap", hidden: !((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hash) === null || _b === void 0 ? void 0 : _b.includes('mailbox')), ref: ref, style: { minWidth: '258px', overflowY: 'hidden', position: 'relative', borderLeft: '1px solid #EBEDF2' } })) : null));
};
const commonParam = {
    config: {
        product: 'weblingxi',
        mode: 'single',
        hideSetting: true,
        hideTopBar: true,
        hidePay: true,
        hideHeader: true,
        hideTablePreview: true,
        requestPlugins: [
            {
                onRequest: async (config) => {
                    console.log('config', config);
                    return config;
                },
                onResponse: async (response) => {
                    console.log('response', response);
                    return response;
                },
            },
        ],
    },
};
const MIN_WIDTH = 320;
const MAX_WIDTH = 480;
export const AiAssistantSidebarSd = () => {
    var _a, _b;
    const ref_sd = useRef(null);
    const ref_resign = useRef(null);
    const ref_personal = useRef(null);
    const [controlModalVisible, setControlModalVisible] = useState2RM('controlModalVisible_sd');
    const [controlModalHasRules, setControlModalHasRules] = useState2RM('controlModalHasRules_sd');
    const [controlRuleModalVisible, setControlRuleModalVisible] = useState(false);
    const [aiResignDocModalVisible, setAiResignDocModalVisible] = useState(false);
    const colors = ['#6557FF', '#00CCAA', '#FE6C5E', '#00C4D6', '#A259FF', '#4C6AFF'];
    const [staffRelations_sd] = useState2RM('staffRelations_sd');
    const [staffRelations_resign] = useState2RM('staffRelations_resign');
    const [aiAssistSideBarVisiable_sd, setAiAssistSideBarVisiable_sd] = useState2RM('aiAssistSideBarVisiable_sd', 'doUpdateAiAssistVisiable_sd');
    const [fold, setFold] = useState(true);
    const [chosenItem, setChosenItem] = useState('all');
    const [AIAssistantRules, setAIAssistantRules] = useState(null);
    const isResignAi = useMemo(() => aiAssistSideBarVisiable_sd.type === 'resign', [aiAssistSideBarVisiable_sd.type]);
    const isPersonalAi = useMemo(() => aiAssistSideBarVisiable_sd.type === 'personal', [aiAssistSideBarVisiable_sd.type]);
    const subordinateListLocal = useMemo(() => {
        let list = staffRelations_sd;
        if (isResignAi) {
            list = staffRelations_resign;
        }
        return list.map(i => (Object.assign(Object.assign({}, i), { color: colors[Math.floor(Math.random() * 6)], nickName: i.staffNickname, email: i.staffEmail })));
    }, [staffRelations_sd.length, staffRelations_resign.length, isResignAi]);
    const [isRenderSD, setIsRenderSD] = useState(false);
    const [isRenderResign, setIsRenderResign] = useState(false);
    const [isRenderPersonal, setIsRenderPersonal] = useState(false);
    const AIAssistantRef_sd = useRef(null);
    const AIAssistantRef_resign = useRef(null);
    const AIAssistantRef_personal = useRef(null);
    const listWrap = useRef(null);
    const [assistantHeight, setAssistantHeight] = useState(184);
    const [width, setWidth] = useState(MIN_WIDTH);
    const RuleForm = useMemo(() => loadable(() => import('@qiyemail/admin-component').then(module => module.RuleForm)), []);
    const HandoverList = useMemo(() => loadable(() => import('@qiyemail/admin-component').then(module => module.HandoverList)), []);
    useEffect(() => {
        contactApi.doGetResignList().then(res => {
            console.log(res);
        });
    }, []);
    useEffect(() => {
        const { visiable, type } = aiAssistSideBarVisiable_sd || {};
        if (visiable && type === 'resign') {
            setChosenItem('all');
        }
    }, [aiAssistSideBarVisiable_sd.visiable]);
    const isSdAi = useMemo(() => {
        return !isResignAi && !isPersonalAi;
    }, [isResignAi, isPersonalAi]);
    useEffect(() => {
        const { visiable, type, data } = aiAssistSideBarVisiable_sd || {};
        const isResignAi = aiAssistSideBarVisiable_sd.type === 'resign';
        const isPersonalAi = aiAssistSideBarVisiable_sd.type === 'personal';
        if (!visiable)
            return;
        if (isResignAi && !ref_resign.current)
            return;
        if (isPersonalAi && !ref_personal.current)
            return;
        if (isSdAi && !ref_sd)
            return;
        const _initWhenReady = () => {
            var _a, _b, _c, _d, _e, _f;
            if (isSdAi && !AIAssistantRef_sd.current) {
                AIAssistantRef_sd.current = new window.aiAssistantWeb.AIAssistants(Object.assign(Object.assign({}, commonParam), { container: ref_sd.current }));
            }
            if (isResignAi && !AIAssistantRef_resign.current) {
                AIAssistantRef_resign.current = new window.aiAssistantWeb.AIAssistants(Object.assign(Object.assign({}, commonParam), { container: ref_resign.current }));
            }
            if (isPersonalAi && !AIAssistantRef_personal.current) {
                AIAssistantRef_personal.current = new window.aiAssistantWeb.AIAssistants({
                    config: Object.assign(Object.assign({}, commonParam.config), { mode: 'multiple', hideHeader: false, hideRemainingTimes: true, hideSidebar: true, hideSetting: false }),
                    container: ref_personal.current,
                });
            }
            let assistant = 'colleague';
            let oprtCmd = 'server.inno.agent.qiyeAiSearch';
            if (isPersonalAi) {
                assistant = 'mail';
                oprtCmd = '';
            }
            if (isResignAi) {
                assistant = 'exEmployee';
                oprtCmd = 'server.inno.agent.qiyeExEmployeeAgent';
            }
            const param = {
                assistant,
                platform: 'lingxi',
                cmd: oprtCmd
                    ? {
                        oprtCmd,
                    }
                    : undefined,
            };
            if (isSdAi) {
                if (type === 'common') {
                }
                else if (type === 'subordinate') {
                    param.cmd.payload = {
                        colleagues: {
                            emails: data,
                        },
                    };
                }
                else if (type === 'mails') {
                    param.cmd.payload = {
                        mailList: {
                            items: data,
                        },
                    };
                }
                else if (type === 'search') {
                    const searchRequest = Object.assign(Object.assign({}, data), { advancedSearchText: '', searchId: '', lastOrderTime: '', limit: 1000 });
                    param.cmd.payload = {
                        searchRequest,
                    };
                    const searchText = (data === null || data === void 0 ? void 0 : data.advancedSearchText) || (data === null || data === void 0 ? void 0 : data.highlight) || '';
                    if (searchText) {
                        const text = `搜索“${searchText}”相关的邮件`;
                        param.cmd.oprtText = text;
                        param.cmd.payload = Object.assign(Object.assign({}, param.cmd.payload), { formData: {
                                content: text,
                            } });
                    }
                }
                console.log(4444, '下属侧边栏', param);
            }
            else {
                if (type === 'resign') {
                    param.cmd.payload = { colleagues: data };
                }
                console.log(4444, '离职员工侧边栏', param);
            }
            if (isSdAi) {
                if (!isRenderSD) {
                    setIsRenderSD(true);
                    (_a = AIAssistantRef_sd.current) === null || _a === void 0 ? void 0 : _a.render(param);
                }
                else {
                    aiAssistantApi.offAllNotification();
                    (_b = AIAssistantRef_sd.current) === null || _b === void 0 ? void 0 : _b.refresh(param);
                }
            }
            if (isResignAi) {
                if (!isRenderResign) {
                    setIsRenderResign(true);
                    (_c = AIAssistantRef_resign.current) === null || _c === void 0 ? void 0 : _c.render(param);
                }
                else {
                    aiAssistantApi.offAllNotification();
                    (_d = AIAssistantRef_resign.current) === null || _d === void 0 ? void 0 : _d.refresh(param);
                }
            }
            if (isPersonalAi) {
                if (!isRenderPersonal) {
                    setIsRenderPersonal(true);
                    (_e = AIAssistantRef_personal.current) === null || _e === void 0 ? void 0 : _e.render(param);
                }
                else {
                    aiAssistantApi.offAllNotification();
                    (_f = AIAssistantRef_personal.current) === null || _f === void 0 ? void 0 : _f.refresh(param);
                }
            }
        };
        if (!window.aiAssistantWeb) {
            const script = document.createElement('script');
            script.src = `${SUB_PATH}/index.umd.1.5.js?t=${new Date().getTime()}`;
            script.onload = () => {
                _initWhenReady();
            };
            document.head.appendChild(script);
        }
        else {
            _initWhenReady();
        }
    }, [aiAssistSideBarVisiable_sd.type, aiAssistSideBarVisiable_sd.time]);
    useEffect(() => {
        let eid;
        if (aiAssistSideBarVisiable_sd.visiable) {
            eid = eventApi.registerSysEventObserver('assistantContextChanged', {
                func: ev => {
                    if (ev && ev.eventData && ev.eventStrData && ev.eventStrData === 'toast') {
                        message.open({ type: ev.eventData.type || 'info', content: ev.eventData.title || getIn18Text('AIZHUSHOUSHIBAI'), duration: ev.eventData.duration || 3 });
                    }
                },
            });
        }
        return () => {
            eventApi.unregisterSysEventObserver('assistantContextChanged', eid);
        };
    }, [aiAssistSideBarVisiable_sd.visiable]);
    useEffect(() => {
        if (!window.$$aiMonitorRuleSetted) {
            window.$$aiMonitorRuleSetted = res => {
                if (res.type === 'success') {
                    console.log(res);
                    setAIAssistantRules(res.rule);
                    setControlRuleModalVisible(false);
                    return;
                }
                if (res.type === 'request_agent_success') {
                    Toast.info({
                        content: getIn18Text('XINZENGXIASQQYTJGLYS6'),
                        duration: 3,
                    });
                    return;
                }
                if (res.type === 'request_agent_error') {
                    Toast.error({
                        content: res.msg || getIn18Text('XINZENGXIASQQSB'),
                        duration: 3,
                    });
                    return;
                }
            };
        }
    }, []);
    const handleClose = () => {
        setAiAssistSideBarVisiable_sd({
            visiable: false,
            type: 'common',
            data: null,
            time: +new Date(),
        });
    };
    const unfoldClick = () => {
        setFold(i => !i);
    };
    useLayoutEffect(() => {
        if (listWrap.current && listWrap.current.clientHeight) {
            setAssistantHeight(listWrap.current.clientHeight + 118);
        }
    }, [fold]);
    useEffect(() => {
        mailApi.getColleagueMonitorRule().then(rules => {
            rules && setAIAssistantRules(rules);
        });
    }, []);
    const subordinateClick = item => {
        setChosenItem(item.staffAccountId);
        if (isResignAi) {
            const resignData = item.staffAccountId === 'all'
                ? null
                : [
                    {
                        id: item.id,
                        orgId: item.orgId,
                        agentId: item.agentId,
                        staffAccountId: item.staffAccountId,
                        staffEmail: item.staffEmail,
                        staffNickname: item.staffNickname,
                        createTime: item.createTime,
                        updateTime: item.updateTime,
                    },
                ];
            setAiAssistSideBarVisiable_sd({
                visiable: true,
                type: 'resign',
                data: resignData,
                time: +new Date(),
            });
            return;
        }
        const emailData = item.staffAccountId === 'all' ? null : [item.staffEmail];
        setAiAssistSideBarVisiable_sd({
            visiable: true,
            type: 'subordinate',
            data: emailData,
            time: +new Date(),
        });
    };
    const closeControlModal = () => {
        setControlModalVisible(false);
        setControlModalHasRules(true);
    };
    const handleMouseDown = e => {
        const startX = e.clientX;
        const startWidth = width;
        const onMouseMove = moveEvent => {
            const newWidth = startWidth + (startX - moveEvent.clientX);
            if (newWidth >= MIN_WIDTH && newWidth <= MAX_WIDTH) {
                setWidth(newWidth);
            }
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { hidden: !((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hash) === null || _b === void 0 ? void 0 : _b.includes('mailbox')) || !aiAssistSideBarVisiable_sd.visiable || process.env.BUILD_ISEDM, style: { minWidth: MIN_WIDTH, maxWidth: MAX_WIDTH, width: width, overflowY: 'hidden', position: 'relative', borderLeft: '1px solid #EBEDF2', height: '100%' } },
            React.createElement("div", { className: styles.dragBar, onMouseDown: handleMouseDown }),
            React.createElement("div", { style: { padding: '0 16px', display: 'flex', alignItems: 'center', height: 48, background: '#f5f6f7' } },
                React.createElement("span", null, getIn18Text('AZL')),
                React.createElement(QiyeIcon, { style: { marginLeft: 8 } }),
                React.createElement(TongyongGuanbiXian, { onClick: handleClose, style: { position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' } })),
            !isPersonalAi && (React.createElement("div", { className: styles.subordinateHeader },
                React.createElement("div", { className: styles.subordinateHeaderL },
                    isResignAi ? React.createElement(AIIconResign, null) : React.createElement("img", { src: AIIconSD, height: 20, width: 20 }),
                    React.createElement("span", null, isResignAi ? 'AI离职员工' : 'AI下属管控助理')),
                !isResignAi && !isPersonalAi && (React.createElement("img", { className: styles.cursorPointer, onClick: () => {
                        setControlModalVisible(true);
                        setControlModalHasRules(true);
                    }, src: subordinateEdit, width: 16 })),
                isResignAi ? (React.createElement(CloudeUploadIcon, { className: styles.cursorPointer, style: { height: '16px', width: '16px' }, onClick: () => {
                        setAiResignDocModalVisible(true);
                    } })) : null)),
            !isPersonalAi && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.subordinateLine }),
                React.createElement("div", { className: styles.subordinateListBox, style: { maxHeight: fold ? 66 : 183 }, ref: listWrap },
                    React.createElement("div", { className: styles.subordinateItem, onClick: () => {
                            subordinateClick({ staffAccountId: 'all' });
                        } },
                        chosenItem === 'all' && React.createElement("img", { src: chosen, width: 32, className: styles.subordinateChosen }),
                        React.createElement("div", { className: classnames(styles.subordinateAvatarAll, styles.subordinateAvatar) }, "ALL"),
                        React.createElement("div", { className: styles.subordinateName }, "\u5168\u90E8")),
                    subordinateListLocal.map(i => (React.createElement("div", { key: i.staffAccountId, className: styles.subordinateItem, onClick: () => {
                            subordinateClick(i);
                        } },
                        +chosenItem === i.staffAccountId && React.createElement("img", { src: chosen, width: 32, className: styles.subordinateChosen }),
                        React.createElement("div", { className: styles.subordinateAvatar, style: { backgroundColor: i.color } }, i.nickName[0]),
                        React.createElement("div", { className: styles.subordinateName }, i.nickName))))),
                subordinateListLocal.length > 7 && (React.createElement("div", { className: styles.listControlWrap },
                    React.createElement("span", { className: classnames(styles.listControl), onClick: unfoldClick },
                        React.createElement(IconCard, { type: fold ? 'arrowDown' : 'arrowUp', stroke: "#3F465C" })))))),
            React.createElement("div", { id: "ai-assistant-wrap_sd", ref: ref_sd, style: { height: `calc(100% - ${assistantHeight}px)`, position: 'relative', display: isResignAi || isPersonalAi ? 'none' : 'block' } },
                React.createElement("div", { style: { height: '100%', display: 'flex', alignItems: 'center' } },
                    React.createElement(Loading, null))),
            React.createElement("div", { id: "ai-assistant-wrap_resign", ref: ref_resign, style: { height: `calc(100% - ${assistantHeight}px)`, position: 'relative', display: !isResignAi ? 'none' : 'block' } },
                React.createElement("div", { style: { height: '100%', display: 'flex', alignItems: 'center' } },
                    React.createElement(Loading, null))),
            React.createElement("div", { id: "ai-assistant-wrap_personal", ref: ref_personal, style: { height: `calc(100% - 48px)`, position: 'relative', display: !isPersonalAi ? 'none' : 'block' } },
                React.createElement("div", { style: { height: '100%', display: 'flex', alignItems: 'center' } },
                    React.createElement(Loading, null)))),
        React.createElement(Modal, { visible: controlModalVisible, className: styles.configModal, width: 440, onCancel: () => {
                closeControlModal();
            }, footer: null, destroyOnClose: true, centered: true },
            React.createElement("div", null,
                !controlModalHasRules && React.createElement("div", null, "\u9996\u6B21\u914D\u7F6E"),
                React.createElement("div", null,
                    React.createElement("img", { src: configBg, width: 400, alt: "" })),
                React.createElement("div", { className: styles.configContent },
                    "\u4E0B\u5C5E\uFF1A",
                    subordinateListLocal.map(i => i.nickName).join('、')),
                React.createElement("div", { className: classnames(styles.displayFlex, styles.configContent) },
                    "\u884C\u4E3A\u76D1\u63A7\uFF1A",
                    !!AIAssistantRules ? (React.createElement("div", null,
                        "\u5DF2\u914D\u7F6E",
                        ' ',
                        React.createElement("span", { className: classnames(styles.colorBrand6, styles.cursorPointer), onClick: () => {
                                setControlRuleModalVisible(true);
                            } }, "\u4FEE\u6539"))) : (React.createElement("span", { className: classnames(styles.colorBrand6, styles.cursorPointer), onClick: () => {
                            setControlRuleModalVisible(true);
                        } }, "\u53BB\u8BBE\u7F6E"))),
                React.createElement("div", { className: styles.configConfirmWrap },
                    React.createElement("span", { className: styles.configConfirm, onClick: () => {
                            if (AIAssistantRules) {
                                closeControlModal();
                                setAiAssistSideBarVisiable_sd({
                                    visiable: true,
                                    type: 'subordinate',
                                    data: null,
                                    time: +new Date(),
                                });
                            }
                            else {
                                Toast.warn({
                                    content: '请先配置行为监控',
                                    duration: 3,
                                });
                            }
                        } }, "\u5B8C\u6210\u914D\u7F6E")))),
        React.createElement(Modal, { visible: controlRuleModalVisible, className: styles.configRuleModal, width: 800, onCancel: () => {
                setControlRuleModalVisible(false);
            }, title: "\u8BBE\u7F6E\u76D1\u63A7\u6761\u4EF6", footer: null, destroyOnClose: true, centered: true },
            React.createElement("iframe", { src: "/static/new/ai-colleague-monitor-rule.html", height: 480, width: 800 })),
        React.createElement(Modal, { visible: aiResignDocModalVisible, className: styles.configRuleModal, width: 800, onCancel: () => {
                setAiResignDocModalVisible(false);
            }, title: "", footer: null, destroyOnClose: true, centered: true },
            React.createElement(HandoverList, null))));
};
const TIME = 30 * 1000;
const AiAssistant = props => {
    var _a, _b;
    const [forbid, setForbid] = useState(false);
    const activeIds = useAppSelector(state => state.mailReducer.activeIds);
    const defaultMailListSelectedModel = useAppSelector(state => state.mailReducer.defaultMailListSelectedModel);
    const configMailLayout = useAppSelector(state => state.mailReducer.configMailLayout);
    const selectedMailId = useAppSelector(state => state.mailReducer.selectedMailId);
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const mailEntities = useAppSelector(state => state.mailReducer.mailEntities);
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const aiAssistSideBarVisiable = useAppSelector(state => state.mailReducer.aiAssistSideBarVisiable);
    const currentMergeMailId = useAppSelector(state => state.mailReducer.currentMergeMailId);
    const selectedKeys = useAppSelector(state => state.mailReducer.selectedKeys);
    const shareMailMid = useAppSelector(state => state.mailReducer.shareMailMid);
    const [aiAssistantWriteMailTip, setAiAssistantWriteMailTip] = useLocalStorage('ai_assistant_write_mail_tip', false);
    const dispatch = useAppDispatch();
    const [aiAssistSideBarVisiable_sd, setAiAssistSideBarVisiable_sd] = useState2RM('aiAssistSideBarVisiable_sd', 'doUpdateAiAssistVisiable_sd');
    const [aiAssistSideBarEnable_sd, setAiAssistSideBarEnable_sd] = useState2RM('aiAssistSideBarEnable_sd');
    const [staffRelations_sd, setStaffRelations_sd] = useState2RM('staffRelations_sd');
    const [aiAssistSideBarEnable_resign, setAiAssistSideBarEnable_resign] = useState2RM('aiAssistSideBarEnable_resign');
    const [staffRelations_resign, setStaffRelations_resign] = useState2RM('staffRelations_resign');
    const [aiAssistSideBarEnable_admin, setAiAssistSideBarEnable_admin] = useState2RM('aiAssistSideBarEnable_admin');
    const [hasShowAiAssistSideBar_sd, setHasShowAiAssistSideBar_sd] = useState2RM('hasShowAiAssistSideBar_sd');
    const [controlModalVisible, setControlModalVisible] = useState2RM('controlModalVisible_sd');
    const [controlModalHasRules, setControlModalHasRules] = useState2RM('controlModalHasRules_sd');
    const [AiType, setAiType] = useState('');
    const [showNewAdmin, setShowNewAdmin] = useState(false);
    const [showNewSd, setShowNewSd] = useState(false);
    const [showNewMsgSd, setShowNewMsgSd] = useState(false);
    const [showNewResign, setShowNewResign] = useState(false);
    const [AiListServerData, setAiListServerData] = useState([]);
    useEffect(() => {
        if (!window.$__AI_ASSISTANT_CONFIG) {
            window.$__AI_ASSISTANT_CONFIG = aiAssistant;
        }
    }, []);
    const getAiListFromServer = async () => {
        const res = await mailApi.AIServerGetAILists();
        setAiListServerData(res);
        return res;
    };
    const timerRef = useRef(null);
    const newMsgLoop = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        timerRef.current = setInterval(() => {
            getAiListFromServer().then(res => {
                var _a;
                const Ai_sd = res.find(ai => +ai.type === 1);
                if (Ai_sd) {
                    setShowNewMsgSd(!!((_a = Ai_sd === null || Ai_sd === void 0 ? void 0 : Ai_sd.settings) === null || _a === void 0 ? void 0 : _a.hasNewMsg));
                }
            });
        }, TIME);
    };
    const handleBackEnd = async () => {
        var _a;
        const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'zh_CN';
        const redirectUrl = mailConfigApi.getNewWebMailHost() + '/admin/login.do?hl=' + hl + '&uid=' + ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) + '&app=admin&all_secure=1&anchor=%2Fhome-ai';
        const url = await mailConfigApi.getWebSettingUrlInLocal('', { url: redirectUrl });
        if (url && url.length > 0) {
            systemApi.openNewWindow(url, false, undefined, undefined, true);
        }
        else {
            Toast.warn({
                content: getIn18Text('WUFADAKAIZHI'),
                duration: 3,
            });
        }
    };
    useEffect(() => {
        if (process.env.BUILD_ISLINGXI && process.env.BUILD_ISWEB) {
            getAiListFromServer().then(res => {
                var _a, _b, _c, _d;
                if (res && res.length) {
                    const Ai_admin = res.find(ai => +ai.type === 0);
                    if (Ai_admin) {
                        setAiAssistSideBarEnable_admin(true);
                        if (!!((_a = Ai_admin === null || Ai_admin === void 0 ? void 0 : Ai_admin.settings) === null || _a === void 0 ? void 0 : _a.new)) {
                            setShowNewAdmin(true);
                        }
                    }
                    const Ai_sd = res.find(ai => +ai.type === 1);
                    if (Ai_sd) {
                        setAiAssistSideBarEnable_sd(true);
                        if (Ai_sd.staffRelations && Ai_sd.staffRelations.length) {
                            setStaffRelations_sd(Ai_sd.staffRelations);
                        }
                        if (!!((_b = Ai_sd === null || Ai_sd === void 0 ? void 0 : Ai_sd.settings) === null || _b === void 0 ? void 0 : _b.new)) {
                            setShowNewSd(true);
                        }
                        setShowNewMsgSd(!!((_c = Ai_sd === null || Ai_sd === void 0 ? void 0 : Ai_sd.settings) === null || _c === void 0 ? void 0 : _c.hasNewMsg));
                        newMsgLoop();
                    }
                    const Ai_resign = res.find(ai => +ai.type === 2);
                    if (Ai_resign) {
                        setAiAssistSideBarEnable_resign(true);
                        if (Ai_resign.staffRelations && Ai_resign.staffRelations.length) {
                            setStaffRelations_resign(Ai_resign.staffRelations);
                        }
                        if (!!((_d = Ai_resign === null || Ai_resign === void 0 ? void 0 : Ai_resign.settings) === null || _d === void 0 ? void 0 : _d.new)) {
                            setShowNewResign(true);
                        }
                    }
                }
            });
            () => {
                timerRef.current && clearInterval(timerRef.current);
            };
        }
    }, []);
    useEffect(() => {
        if (process.env.BUILD_ISLINGXI && process.env.BUILD_ISWEB) {
            if (currentTab.type === tabType.subordinate && !aiAssistSideBarVisiable_sd.visiable && aiAssistSideBarEnable_sd && !hasShowAiAssistSideBar_sd) {
                sdIconClick();
                setHasShowAiAssistSideBar_sd(true);
            }
        }
    }, [currentTab, aiAssistSideBarEnable_sd, hasShowAiAssistSideBar_sd]);
    useEffect(() => {
        if (aiAssistSideBarVisiable_sd.visiable) {
            setHasShowAiAssistSideBar_sd(true);
        }
    }, [aiAssistSideBarVisiable_sd.visiable]);
    useEffect(() => {
        let _activeIds = [...activeIds];
        if (defaultMailListSelectedModel !== LIST_MODEL.MULTIPLE) {
            _activeIds = [];
        }
        const data = _activeIds.map(_ => {
            var _a;
            return {
                id: _,
                _account: ((_a = mailEntities[_]) === null || _a === void 0 ? void 0 : _a._account) || '',
            };
        });
        aiAssistantApi.sendNotification({ type: 'multipleMail', data: data });
    }, [activeIds, defaultMailListSelectedModel]);
    useEffect(() => {
        var _a;
        const data = cloneDeep(currentTab);
        if (!data.extra) {
            data.extra = {};
        }
        const _account = ((_a = mailEntities[data.extra.originId || data.extra.originMid]) === null || _a === void 0 ? void 0 : _a._account) || '';
        data.extra.accountId = _account;
        aiAssistantApi.sendNotification({ type: 'currentTab', data: data });
    }, [currentTab]);
    useEffect(() => {
        aiAssistantApi.sendNotification({ type: 'configMailLayout', data: configMailLayout });
    }, [configMailLayout]);
    useEffect(() => {
        var _a;
        const data = cloneDeep(selectedMailId);
        const _account = ((_a = mailEntities[data === null || data === void 0 ? void 0 : data.id]) === null || _a === void 0 ? void 0 : _a._account) || '';
        data.accountId = _account;
        aiAssistantApi.sendNotification({ type: 'selectedMailId', data: data });
    }, [selectedMailId]);
    useEffect(() => {
        if (aiAssistSideBarVisiable_sd.visiable) {
            aiAssistantApi.sendNotification({ type: 'currentWriteMail', data: cloneDeep(currentMail) });
        }
    }, [currentMail, aiAssistSideBarVisiable_sd]);
    useEffect(() => {
        aiAssistantApi.sendNotification({ type: 'aiAssistSideBarVisiable', data: aiAssistSideBarVisiable });
    }, [aiAssistSideBarVisiable]);
    useEffect(() => {
        aiAssistantApi.sendNotification({ type: 'aiAssistSideBarVisiable_sd', data: aiAssistSideBarVisiable_sd });
    }, [aiAssistSideBarVisiable_sd]);
    useEffect(() => {
        aiAssistantApi.sendNotification({ type: 'currentMergeMailId', data: currentMergeMailId });
    }, [currentMergeMailId]);
    useEffect(() => {
        aiAssistantApi.sendNotification({ type: 'selectedKeysAccountId', data: (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '' });
    }, [selectedKeys]);
    const loopGetAiForbiddenDomains = () => {
        let time = 0;
        let si = setInterval(() => {
            try {
                time++;
                if (time > 5) {
                    clearInterval(si);
                    return;
                }
                const forbidList = JSON.parse(productAuthApi.getABSwitchSync('mail_ai_forbidden_domains'));
                if (forbidList) {
                    clearInterval(si);
                    if (forbidList && forbidList.length) {
                        const userInfo = systemApi.getCurrentUser();
                        if (forbidList.find((item) => { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.endsWith(item); })) {
                            setForbid(true);
                        }
                    }
                }
            }
            catch (e) {
                console.error('获取AI隐藏域名失败', e);
            }
        }, 200);
    };
    useEffect(() => {
        if (!isEdm()) {
            try {
                loopGetAiForbiddenDomains();
            }
            catch (e) {
                console.error('获取AI隐藏域名失败', e);
            }
        }
    }, []);
    const iconClick = () => {
        dispatch(MailActions.doUpdateAiAssistVisiable(true));
    };
    const openAiAssistant = () => {
        dispatch(MailActions.doUpdateAiAssistVisiable(true));
        setAiAssistantWriteMailTip(true);
    };
    const readMsg = useCreateCallbackForEvent(() => {
        const aiSd = AiListServerData.find(ai => ai.type === 1);
        if (aiSd && aiSd.id && showNewMsgSd) {
            mailApi.AIServerReadMsg(aiSd.id);
            setShowNewMsgSd(false);
        }
    });
    const readNew = useCreateCallbackForEvent((type) => {
        var _a;
        let aiTypeNum = undefined;
        if (type === 'aiAssistSideBarEnable_admin') {
            aiTypeNum = 0;
        }
        else if (type === 'aiAssistSideBarEnable_sd') {
            aiTypeNum = 1;
        }
        else if (type === 'aiAssistSideBarEnable_resign') {
            aiTypeNum = 2;
        }
        const ai = AiListServerData.find(ai => +ai.type === aiTypeNum);
        if (ai && ai.id && !!((_a = ai === null || ai === void 0 ? void 0 : ai.settings) === null || _a === void 0 ? void 0 : _a.new)) {
            mailApi.AIServerReadNew(ai.id);
        }
    });
    const adminIconClick = () => {
        setShowNewAdmin(false);
        handleBackEnd();
    };
    const sdIconClick = async () => {
        const hasRuleSd = await mailApi.getColleagueMonitorRule();
        if (hasRuleSd) {
            setAiAssistSideBarVisiable_sd({
                visiable: true,
                type: 'common',
                time: +new Date(),
            });
        }
        else {
            setControlModalVisible(true);
            setControlModalHasRules(false);
        }
        readMsg();
        setShowNewSd(false);
    };
    const resignIconClick = () => {
        setAiAssistSideBarVisiable_sd({
            visiable: true,
            type: 'resign',
            time: +new Date(),
        });
        setShowNewResign(false);
    };
    const personalIconClick = () => {
        setAiAssistSideBarVisiable_sd({
            visiable: true,
            type: 'personal',
            time: +new Date(),
        });
    };
    const handleMenuClick = ({ item, key }) => {
        setAiType(key);
        readNew(key);
    };
    const aiAssistEnable = useMemo(() => !forbid, [forbid]);
    const aiAssistList = useMemo(() => {
        const list = [
            {
                type: 'aiAssistEnable',
                text: getIn18Text('AZL'),
                show: aiAssistEnable,
                click: personalIconClick,
                icon: React.createElement("img", { src: AIIconCommon, height: 20, width: 20 }),
            },
            {
                type: 'aiAssistSideBarEnable_admin',
                text: getIn18Text('AGLYZL'),
                show: aiAssistSideBarEnable_admin,
                click: adminIconClick,
                icon: React.createElement(AIIconAdmin, null),
            },
            {
                type: 'aiAssistSideBarEnable_sd',
                text: getIn18Text('AXSGKZL'),
                show: aiAssistSideBarEnable_sd,
                click: sdIconClick,
                icon: React.createElement("img", { src: AIIconSD, height: 20, width: 20 }),
            },
            {
                type: 'aiAssistSideBarEnable_resign',
                text: getIn18Text('ALZYG'),
                show: aiAssistSideBarEnable_resign,
                click: resignIconClick,
                icon: React.createElement(AIIconResign, null),
            },
        ];
        return list.filter(obj => !!obj.show);
    }, [aiAssistEnable, aiAssistSideBarEnable_sd, aiAssistSideBarEnable_resign, aiAssistSideBarEnable_admin]);
    const menu = useMemo(() => (React.createElement(Menu, { className: styles.toobarHelpMenu, onClick: handleMenuClick }, aiAssistList.map(ai => {
        return (React.createElement(Menu.Item, { key: ai.type, onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                ai.click && ai.click();
            } },
            React.createElement("div", { className: styles.menuItem },
                React.createElement("span", { className: ai.type === 'aiAssistSideBarEnable_sd' && showNewMsgSd ? styles.newMsg : styles.itemIcon }, ai.icon),
                React.createElement("span", { title: ai.text, style: { marginLeft: 8 } }, ai.text),
                ai.type === 'aiAssistSideBarEnable_admin' && !!showNewAdmin && React.createElement(AIIconNew, { style: { marginLeft: 8 } }),
                ai.type === 'aiAssistSideBarEnable_sd' && !!showNewSd && React.createElement(AIIconNew, { style: { marginLeft: 8 } }),
                ai.type === 'aiAssistSideBarEnable_resign' && !!showNewResign && React.createElement(AIIconNew, { style: { marginLeft: 8 } }))));
    }))), [aiAssistList.length, showNewSd, showNewResign, showNewMsgSd, showNewAdmin]);
    const rightIcon = useMemo(() => {
        let aiAssist;
        if (aiAssistList.length > 1) {
            if (!!AiType) {
                aiAssist = aiAssistList.find(ai => ai.type === AiType);
            }
            else {
                aiAssist = aiAssistList[0];
            }
        }
        else if (aiAssistList.length === 1) {
            aiAssist = aiAssistList[0];
        }
        return (aiAssist === null || aiAssist === void 0 ? void 0 : aiAssist.icon) ? (React.createElement("span", { style: { marginRight: 4 }, className: showNewMsgSd ? styles.newMsgTop : styles.itemIcon }, aiAssist.icon)) : (React.createElement(React.Fragment, null));
    }, [aiAssistList.length, AiType, showNewMsgSd]);
    const rightText = useMemo(() => {
        if (aiAssistList.length > 1) {
            if (!!AiType) {
                const temp = aiAssistList.find(ai => ai.type === AiType);
                if (temp) {
                    return temp.text;
                }
                else {
                    return React.createElement(React.Fragment, null);
                }
            }
            else {
                return aiAssistList[0].text;
            }
        }
        else if (aiAssistList.length === 1) {
            return aiAssistList[0].text;
        }
        return React.createElement(React.Fragment, null);
    }, [aiAssistList.length, AiType]);
    const rightNew = useMemo(() => {
        if (!!aiAssistList.length) {
            if (!!showNewAdmin || !!showNewSd || !!showNewResign) {
                return React.createElement(AIIconNew, { style: { marginLeft: 4 } });
            }
        }
        return React.createElement(React.Fragment, null);
    }, [aiAssistList.length, showNewAdmin, showNewSd, showNewResign]);
    if (process.env.BUILD_ISEDM || !((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hash) === null || _b === void 0 ? void 0 : _b.includes('mailbox')) || !!shareMailMid) {
        return React.createElement(React.Fragment, null);
    }
    return !!aiAssistList.length ? (aiAssistList.length === 1 ? (React.createElement("div", { className: styles.assistantIconWrap, onClick: () => {
            aiAssistList[0].click();
            readNew(aiAssistList[0].type);
        } },
        rightIcon,
        rightText,
        rightNew)) : (React.createElement(Dropdown, { overlay: menu, placement: "bottomRight" },
        React.createElement("div", { className: styles.assistantIconWrap },
            rightIcon,
            rightText,
            rightNew,
            React.createElement(IconTriangleDown, { style: { marginLeft: 9 } }))))) : (React.createElement(React.Fragment, null));
};
export default AiAssistant;
